import msgDateFormatter from "../../../utils/helpers/msgDateFormatter";
import {snippetType} from "./messagesTypes";

export const setDialogMap = (el: any) => {
    return (
        el.map((el: any) => ({
            id: el.previewUser.previewUserInfo.id,
            idSender: el.lastMessage?.idSender,
            idRecipient: el.lastMessage?.idRecipient,
            replyTo: el.lastMessage?.replyTo,
            time: el.lastMessage?.dateCreate,
            edit: el.lastMessage?.edit,
            text: el.lastMessage?.text || "Фотография",
            mediaType: el.lastMessage?.mediaType,
            readStatus: el.lastMessage?.readStatus,
            previewUserInfo: {
                ...el.previewUser?.previewUserInfo,
                photoSmall: el.previewUser?.mainPhoto?.photoCropSmall || el.previewUser?.mainPhoto?.photoSmall,
                isOnline: el.previewUser?.onlineStatus?.online
            },
            folderExists: el.idFoldersExistInfo,
            countUnreadMessages: el.countUnreadMessages,
            isMeBlocked: el.userBanProfile,
            mainPhotoVerifiedStatus: el.previewUser.mainPhotoVerifiedStatus,
            systemBanStatus: el.userStatus?.systemBanStatus !== undefined ? true : false,
            deletedDate: el.userStatus?.deletedDate
        }))
    )
}

// Сервер отдаёт replyTo числом или строкой "None" (как в приле — models.js).
export const normalizeReplyTo = (v: any): number | undefined => {
    if (v === null || v === undefined || v === "None" || v === "") return undefined;
    const n = Number(v);
    return Number.isFinite(n) && n > 0 ? n : undefined;
}

export const setMessagesMap = (el: any) => {

    return (
        el.map((el:any) => ({
            id: el.messageInfo?.id,
            idSender: el.messageInfo?.idSender,
            idRecipient: el.messageInfo?.idRecipient,
            replyTo: normalizeReplyTo(el.messageInfo?.replyTo),
            time: el.messageInfo?.dateCreate,
            edit: el.messageInfo?.edit,
            text: el.messageInfo?.text,
            mediaType: el.messageInfo?.mediaType,
            readStatus: el.messageInfo?.readStatus,
            photosNormal: el.messagePhotosName?.map((el:any) => el.photoNormal),
            photosLarge: el.messagePhotosName?.map((el:any) => el.photoLarge),
            systemMessageType: el.messageInfo?.systemMessageType,
            date: msgDateFormatter(el.messageInfo?.dateCreate),
            milliseconds: Date.parse(el.messageInfo?.dateCreate)
        }))
    )
}

export const setSnippetsMap = (el: any) => {

    return (
        el.map((el:snippetType) =>({
            lastMessage: {
                idSender: el.lastMessage?.idSender,
                text: el.lastMessage?.text || "Фотография",
                readStatus: (el.lastMessage?.idSender === el.previewUser?.previewUserInfo.id) ? el.lastMessage?.readStatus : 'none'
            },
            previewUser: {
                mainPhotoVerifiedStatus: el.previewUser?.mainPhotoVerifiedStatus,
                previewUserInfo: {
                    id: el.previewUser?.previewUserInfo.id,
                    name: el.previewUser?.previewUserInfo.name,
                },
                mainPhoto: {
                    photoSmall: el.previewUser?.mainPhoto?.photoCropSmall || el.previewUser?.mainPhoto?.photoSmall
                },
                onlineStatus: {
                    online: el.previewUser.onlineStatus.online
                },
                systemBanStatus: el.userStatus?.systemBanStatus !== undefined ? true : false,
                deletedDate: el.userStatus?.deletedDate
            }
        }))
    )
}
